module.exports = __webpack_public_path__ + "static/media/1006127.6173ae40.png";